import { CreateCCParams, MpPayload } from '../types/payment-strategy.types';
import { buildCommonCC, goToProcessing } from '../utils/cc-utils';
import { emitUtmifyEvent } from '../utils/emitUtmifyEvent';

export const cardMpStrategy = async ({
  data,
  checkout,
  id,
  api,
  gerarTokenRecaptcha,
  navigate,
  location,
  getUrlParams,
  paymentMethod,
  alert,
}: any) => {
  const mp: MpPayload | undefined = data?.card;
  if (!mp?.token) {
    alert.error('Não foi possível gerar o token do cartão (MP).');
    throw new Error('Missing Mercado Pago token');
  }

  const recaptcha = await gerarTokenRecaptcha(`/venda`);
  const afiliadoId = getUrlParams('affiliate') ?? undefined;

  const payload: CreateCCParams = {
    metodoPagamento: paymentMethod,
    produtoId: id ?? '',
    ...buildCommonCC(data),
    token: mp.token,
    checkoutId: checkout?.id,
    recaptchaToken: recaptcha,
    installments: mp.installments ?? 1,
    paymentMethodId: mp.payment_method_id ?? null,
    issuer: mp.issuer_id ? Number(mp.issuer_id) : null,
    cvvCardId: data?.cvvCardId,
    afiliadoId,
  };

  const purchase = await api.Venda.createCC(payload);
  emitUtmifyEvent({
    event: 'waiting_payment',
    vendaId: purchase.data?.id,
  });
  const { card, ...safeContract } = data;
  goToProcessing(navigate, location.search, purchase, checkout, safeContract);
};
